import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { ProductionCommandType } from '@src/suite/common/utils/ml-2-html-utils';
import { ToolbarButtons } from 'froala-editor';

import { CardViewType, CustomMatIcon, EditorActions } from './enums';

export const ENPS_PREFIX = 'V7OBJ:';
export const PST_PREFIX = 'PSTOBJ:';

export const ST_CRITERIA_SECURITY_ROLE = 'SECURITY_ROLE';

export const OPTION_ALL = '@all';
export const OPTION_BLANK = '@blank';
export const OPTION_YES = '@yes';
export const OPTION_NO = '@no';
export const OPTION_ME = '@staff_id_me';
export const OPTION_ANY = '@any';

export const PUBLICATION_LIST_TIME_TODAY = '@today';
export const PUBLICATION_LIST_TIME_TOMORROW = '@today_day_1';
export const PUBLICATION_LIST_TIME_TODAY_DAY_TWO = '@today_day_2';
export const PUBLICATION_LIST_TIME_TODAY_DAY_THREE = '@today_day_3';
export const PUBLICATION_LIST_TIME_TODAY_DAY_FOUR = '@today_day_4';
export const PUBLICATION_LIST_TIME_TODAY_DAY_FIVE = '@today_day_5';
export const PUBLICATION_LIST_TIME_TODAY_DAY_SIX = '@today_day_6';
export const PUBLICATION_LIST_TIME_TODAY_DAY_SEVEN = '@today_day_7';

export const NAVIGATION_STORAGE_KEY: string = 'NGRX_Navigation';

export const PUBLICATION_LIST_TIME_OPTIONS: Array<{ id: string; title: string }> = [
    {
        id: PUBLICATION_LIST_TIME_TODAY,
        title: 'Today',
    },
    {
        id: PUBLICATION_LIST_TIME_TOMORROW,
        title: 'Tomorrow',
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_TWO,
        title: 'Today + 2',
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_THREE,
        title: 'Today + 3',
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_FOUR,
        title: 'Today + 4',
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_FIVE,
        title: 'Today + 5',
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_SIX,
        title: 'Today + 6',
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_SEVEN,
        title: 'Today + 7',
    },
];

export const PUBLICATION_LIST_TIME_DAYS_MAP = {
    [PUBLICATION_LIST_TIME_TODAY]: 0,
    [PUBLICATION_LIST_TIME_TOMORROW]: 1,
    [PUBLICATION_LIST_TIME_TODAY_DAY_TWO]: 2,
    [PUBLICATION_LIST_TIME_TODAY_DAY_THREE]: 3,
    [PUBLICATION_LIST_TIME_TODAY_DAY_FOUR]: 4,
    [PUBLICATION_LIST_TIME_TODAY_DAY_FIVE]: 5,
    [PUBLICATION_LIST_TIME_TODAY_DAY_SIX]: 6,
    [PUBLICATION_LIST_TIME_TODAY_DAY_SEVEN]: 7,
};

export const PSTWEB_LIST_VALUE = 'PSTWebListValue';
export const PSTWEB_BUTTON_HT = 'PSTWebButtonHT';

export const DARK_MODE_KEY = 'dark-mode';

export const APP_THEMES_MAP = {
    playbook: 'storytelling-theme',
    journal: 'storytelling-theme',
    live: 'storytelling-theme',
    cast: 'storytelling-theme',
    discover: 'storytelling-theme',
    embedded: 'storytelling-theme',
};

export const StorytellingLayoutBreakpoints = {
    XSmall: '(max-width: 599.98px)',
    Small: '(min-width: 600px) and (max-width: 899.98px)',
    Medium: '(min-width: 900px) and (max-width: 1279.98px)',
    Large: '(min-width: 1280px) and (max-width: 1439.98px)',
    XLarge: '(min-width: 1440px) and (max-width: 1919.98px)',
    XXLarge: '(min-width: 1920px)',
    // Handset: string; //IN CASE WE NEED
    // Tablet: string; //IN CASE WE NEED
    // Web: string; //IN CASE WE NEED
    // HandsetPortrait: string; //IN CASE WE NEED
    // TabletPortrait: string; //IN CASE WE NEED
    // WebPortrait: string; //IN CASE WE NEED
    // HandsetLandscape: string; //IN CASE WE NEED
    // TabletLandscape: string; //IN CASE WE NEED
    // WebLandscape: string; //IN CASE WE NEED
};

export const APMediaEndpoint = 'wires/v2/media';

export const INITIAL_TIME_STAMP = '00:00:00';

export const CUSTOM_MAT_ICONS = Object.values(CustomMatIcon);
export const CUSTOM_MAT_ICONS_DEFINITIONS: {
    name: CustomMatIcon;
    path: string;
}[] = CUSTOM_MAT_ICONS.map(icon => ({
    name: icon,
    path: `assets/images/mat_icon_${icon}.svg`,
}));

// NORMAL CARDS

// 136px + 2px spacing
export const CARD_HEIGHT = 138;
// 32px + 2px spacing
export const CHILD_CARD_HEADER_HEIGHT = 34;
// 136 + 8px spacing
export const CARD_LAST_ITEM_HEIGHT = 144;
// 32px + 2px spacing
export const GROUP_HEADER_HEIGHT = 34;
export const CUSTOM_FIELDS_ADDED_HEIGHT = 44;

// CONDENSED CARDS
// 48px + 2px spacing
export const CONDENSED_CARD_HEIGHT = 50;
// 48px + 8px spacing
export const CONDENSED_LAST_ITEM_HEIGHT = 56;
// 24px header + 2px spacing
export const CONDENSED_FIRST_ITEM_HEADER_HEIGHT = 26;

// CUSTOM FIELDS
export const CUSTOM_FIELDS_HEIGHT = 44;

export const CARD_WIDTH_LOWER_BREAKPOINTS = {
    [CardViewType.LARGE]: 1152,
    [CardViewType.MEDIUM]: 548,
};

export const SYSTEM_VS_GUID = 'SYSTEM_VS_GUID';
export const SYSTEM_VS_NAME_TOPIC = 'Current Topic';
export const SYSTEM_VS_NAME_RUNDOWN = 'Current Rundown';

export const PRODUCTION_COMMAND_BUTTONS = [
    ProductionCommandType.TAKE,
    ProductionCommandType.INSERT,
    ProductionCommandType.ANCHOR,
    ProductionCommandType.READRATE,
    ProductionCommandType.DURATION,
    ProductionCommandType.NOTES,
];

export const CUSTOM_EDITOR_BUTTONS = [EditorActions.SAVE];
export const CUSTOM_EDITOR_BUTTONS_ACTIONS = {
    [EditorActions.SAVE]: 'save',
};

export const FROALA_DEFAULT_TOOLBAR_ITEMS: Partial<ToolbarButtons> = {
    moreText: {
        buttons: [EditorActions.SAVE, 'fontFamily', 'fontSize', 'bold', 'italic', 'strikeThrough'],
        buttonsVisible: 5,
    },
    moreRich: {
        buttons: ['insertLink'],
        buttonsVisible: 1,
    },
};

// Cast card heights
// 142px + 2px spacing
export const CAST_CARD_HEIGHT = 144;
// 32px + 2px spacing
// export const CHILD_CARD_HEADER_HEIGHT = 34;
// 136 + 8px spacing
export const CAST_CARD_LAST_ITEM_HEIGHT = 152;
// 32px + 2px spacing
export const CAST_GROUP_HEADER_HEIGHT = 34;

export const STORY_MOS_PROPERTIES = {
    [PSTFieldNames.MOSStatus]: true,
    [PSTFieldNames.MOSAbstracts]: true,
    [PSTFieldNames.MOSIDs]: true,
    [PSTFieldNames.MOSItemDurations]: true,
    [PSTFieldNames.MOSTimes]: true,
    // [PSTFieldNames.MOSChannels]: true,
    [PSTFieldNames.MOSItemEdDurations]: true,
    [PSTFieldNames.MOSSlugs]: true,
    [PSTFieldNames.MOSObjSlugs]: true,
    [PSTFieldNames.MOSItemTiming]: true,
};
